export enum Delimiter {
    COMMA = ',',
    SEMICOLON = ';',
}

export interface ImportValidationErrorData {
    invalidGroupError: number;
    parseSecretError: number;
    invalidSecretError: number;
    invalidUserError: number;
    personalSecretError?: number;
    invalidUserIds?: string[];
    invalidGroupIds?: string[];
}
